import { ClientAuth, Store } from '@/classes';
import { useRouter } from '@/hooks/useRouter';
import { useCallback, useMemo, useRef } from 'react';

export const SplashPage = () => {
  const router = useRouter();
  const videoRef = useRef<HTMLVideoElement>(null);
  const hasStarted = useRef(false);
  const didNavigate = useRef(false);

  const navigateToMain = useCallback(() => {
    if (didNavigate.current) return;
    didNavigate.current = true;
    if (ClientAuth.user) {
      router.push('/home', { replace: true });
    } else {
      router.push('/login', { replace: true });
    }
  }, [router]);

  const handleCanPlay = useCallback(async () => {
    if (hasStarted.current || !videoRef.current) return;
    hasStarted.current = true;
    try {
      await videoRef.current.play();
    } catch {
      navigateToMain();
    }
  }, [navigateToMain]);

  const handleError = useCallback(
    (e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
      console.error(e);
      navigateToMain();
    },
    [navigateToMain],
  );

  const mute = useMemo(() => sessionStorage.getItem('autoPlay') !== 'true', []);
  const src = useMemo(() => Store.get('resources').splashMainVideo.landscape, []);

  return (
    <div className="bg-black w-[1920px] h-[1080px]">
      <video
        ref={videoRef}
        className="w-full h-full"
        src={src}
        onEnded={navigateToMain}
        onError={handleError}
        onCanPlay={handleCanPlay}
        muted={mute}
        controls={false}
      />
    </div>
  );
};
